import { createTranslationResource } from '@backstage/core-plugin-api/alpha';
import { searchTranslationRef } from '@backstage/plugin-search/alpha';
import { searchReactTranslationRef } from '@backstage/plugin-search-react/alpha';


export const searchTranslations = createTranslationResource({
    ref: searchTranslationRef,
    translations: {
        pl: () => import('./search-pl'),
    },
});

export const searchReactTranslations = createTranslationResource({
    ref: searchReactTranslationRef,
    translations: {
        pl: () => import('./search-react-pl'),
    },
});
